import styled from 'styled-components';

import { Box } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

import { ReasonTagVariant } from './ReasonTag.types';

export const ContentEditable = styled(Box)`
  &:focus-visible,
  &:focus {
    outline: none;
  }

  &[contenteditable='true']:empty:before {
    content: attr(placeholder);
  }

  /* it prevents the user from being able to make a (visible) newline */

  &[contenteditable='true'] {
    & br {
      display: none;
    }

    & div {
      display: inline;
    }
  }
`;

export const ReasonTagStyled = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: ${ct({ Dark: Colors.Dark, Light: Colors.Dark })};

  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid ${ct({ Dark: Colors.Grey, Light: Colors.Grey })};

  &:not(:disabled)[data-has-cursor-pointer='true'] {
    cursor: pointer;
  }

  &[aria-selected='true'] {
    background-color: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
    border-color: ${ct({ Dark: Colors.VioletMiddleLighter, Light: Colors.VioletMiddleLighter })};
  }

  &[data-variant='${ReasonTagVariant.Primary}'] {
    border-style: solid;
  }

  &[data-variant='${ReasonTagVariant.Secondary}'] {
    border-style: dashed;
  }
`;
